interface IconProps {
    src: string;
    alt: string;
    width: number;
    height: number;
    onClick?: () => void;
}

export default function MyIcon({ src, alt, width, height, onClick }: IconProps) {
    return (
        <div>
            <img src={src} alt={alt} width={width} height={height} onClick={onClick} />
        </div>
    )
}